module.exports = __webpack_public_path__ + "media/target_area_icon/dept_accounting-3d126428.png";